import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { getDateString } from '../helpers/date.helper';
import { getFirstName, getLastName } from '../helpers/string.helper';
import { LocalStorageService } from './local-storage.service';

@Injectable({
	providedIn: 'root',
})
export class TagManagerService {
	constructor(
		@Inject(PLATFORM_ID) private platformId: Object,
		private localStorage: LocalStorageService
	) {}

	setTagManager(events: any): void {
		if (isPlatformBrowser(this.platformId)) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(events);
		}
	}

	kebabCaseConvert(text?: string): string {
		if (typeof text === 'string')
			return text
				.replace(/([a-z])([A-Z])/g, '$1-$2')
				.replace(/[\s_]+/g, '-')
				.toLowerCase();
		return '';
	}

	//* nova forma de lidar com SHA-256 sem uso de bibliotecas externas

	async ecryptText(text?: string): Promise<string> {
		if (isPlatformBrowser(this.platformId) && typeof text === 'string') {
			const encoder = new TextEncoder();
			const data = encoder.encode(text.toLowerCase());
			const hashBuffer = await crypto.subtle.digest('SHA-256', data);
			const hashArray = Array.from(new Uint8Array(hashBuffer));
			const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
			return hashHex;
		}
		return '';
	}

	async getUserDataEcrypt(): Promise<object> {
		let user: any = this.localStorage.getItem('ROD-logged.userData');
		if (user !== undefined && user !== null && typeof user === 'string') {
			user = JSON.parse(user);
			const birthdate = getDateString(new Date(user?.birthdate));
			return {
				client: 'logado',
				'id-do-usuario': user?.id,
				sha256_name: await this.ecryptText(getFirstName(user?.name)),
				'sha256_last-name': await this.ecryptText(getLastName(user?.name)),
				sha256_email: await this.ecryptText(user?.email),
				sha256_phone: await this.ecryptText(user?.cellphone),
				sha256_birthdate: await this.ecryptText(birthdate),
				'sha256_postal-cod': await this.ecryptText(user?.cep),
				sha256_city: await this.ecryptText(user?.city?.trim()),
				sha256_country: await this.ecryptText('br'),
			};
		}
		return {
			client: 'nao-logado',
		};
	}
}
